import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { StarRatingModule } from 'angular-star-rating';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
// import { authApiKeyInterceptor } from './core/interceptor/apikey.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(
      withInterceptors([
        // authApiKeyInterceptor
      ])
    ),
    provideRouter(appRoutes),
    provideAnimationsAsync(),
    importProvidersFrom(StarRatingModule.forRoot()),
  ],
};
